(function (angular) {
    'use strict';

    angular.module('whatsApp')

        /**
         *
         */
        .factory('whatsAppServices',
            ['$http', '$q', 'portalConfig', 'whatsAppSharedService',
                function ($http, $q, portalConfig, whatsAppSharedService) {

                    var urlBase = portalConfig.urlBase;
                    var fac = {
                        getWhatsAppCloudConfigurations: getWhatsAppCloudConfigurations,
                        removeWhatsAppCloudConfiguration: removeWhatsAppCloudConfiguration,
                        getAllWhatsAppConfigurations: getAllWhatsAppConfigurations,
                        getSuccessfulWhatsAppCloudConfigurations: getSuccessfulWhatsAppCloudConfigurations,
                        getSingleWhatsAppConfiguration: getSingleWhatsAppConfiguration,
                        startVerificationProcess: startVerificationProcess,
                        sendVerificationCode: sendVerificationCode,
                        getHsms: getHsms,
                        getHsm: getHsm,
                        updateBusinessProfilePhoto: updateBusinessProfilePhoto,
                        deleteBusinessProfilePhoto: deleteBusinessProfilePhoto,
                        updateBusinessProfile: updateBusinessProfile
                    };

                    return fac;

                    function getSuccessfulWhatsAppCloudConfigurations(apiSpaceId) {
                        return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/channels/whatsapp/cloud?success=true").then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    }

                    function getWhatsAppCloudConfigurations(apiSpaceId, wabaIds, phoneNumbers) {
                        let url = urlBase + "/apispaces/" + apiSpaceId + "/channels/whatsapp/cloud?configurationStatus=success";
                        url = wabaIds ? `${url}&wabaIds=${formatArrayForUrl(wabaIds)}` : url;
                        url = phoneNumbers ? `${url}&phoneNumbers=${formatArrayForUrl(phoneNumbers)}` : url;

                        return $http.get(url).then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    }

                    function removeWhatsAppCloudConfiguration(apiSpaceId, phoneNumber) {
                        return $http.delete(`${urlBase}/apispaces/${apiSpaceId}/channels/whatsapp/cloud/${phoneNumber}`).then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    }

                    function getAllWhatsAppConfigurations(apiSpaceId) {
                        return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/channels/whatsapp").then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    }

                    function getSingleWhatsAppConfiguration(apiSpaceId, phoneNumber) {
                        return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/channels/whatsapp/" + phoneNumber).then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    }

                    function startVerificationProcess(apiSpaceId, phoneNumber, verifyMethod, pin) {
                        var data = {
                            verifyMethod: verifyMethod,
                            pin: pin
                        };
                        return $http.put(urlBase + "/apispaces/" + apiSpaceId + "/channels/whatsapp/" + phoneNumber + "/verification", data).then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    };

                    function sendVerificationCode(apiSpaceId, phoneNumber, code) {
                        var data = {
                            verifyCode: code
                        };
                        return $http.patch(urlBase + "/apispaces/" + apiSpaceId + "/channels/whatsapp/" + phoneNumber + "/verification", data).then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    }

                    function getHsms(apiSpaceId) {
                        var hsms = whatsAppSharedService.getHsms(apiSpaceId);
                        if (hsms) {
                            return $q.resolve(hsms);
                        }
                        return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/channels/whatsapp/hsms").then(function (response) {
                            whatsAppSharedService.saveHsms(apiSpaceId, response.data);

                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    }

                    function getHsm(apiSpaceId, templateName) {
                        return getHsms(apiSpaceId).then(function () {
                            return whatsAppSharedService.getHsm(apiSpaceId, templateName);
                        });
                    }

                    function updateBusinessProfile(apiSpaceId, phoneNumber, data) {
                        return $http.put(urlBase + "/apispaces/" + apiSpaceId + "/channels/whatsapp/" + phoneNumber + "/profile", data).then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    }


                    function updateBusinessProfilePhoto(apiSpaceId, phoneNumber, url) {
                        var data = {
                            url: url
                        };
                        return $http.put(urlBase + "/apispaces/" + apiSpaceId + "/channels/whatsapp/" + phoneNumber + "/profile/photo", data).then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    }

                    function deleteBusinessProfilePhoto(apiSpaceId, phoneNumber) {
                        return $http.delete(urlBase + "/apispaces/" + apiSpaceId + "/channels/whatsapp/" + phoneNumber + "/profile/photo").then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    }

                    function formatArrayForUrl(array) {
                        if (!array || array?.length === 0) {
                            return "[]"; // Return an empty array if the input is null, undefined, or empty
                        }
                        return `[${array.map(item => `"${item}"`).join(",")}]`;
                    }
                }]);

})(window.angular);
